<template lang="pug">
.match-bet-area-group.flex-grow-2
  .match-bet-area-type
    .match-bet-area-type-title {{ leagueName.trim() }}
    .match-odd-area
      .match-odd-area-oddtype
        p.mb-0 {{ $t("m.ODD_Home") }}
        p.mb-0 {{ $t("m.ODD_Away") }}
      template(v-for="(dn, i) in details['tn']")
        .match-odd-area-group
          .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_MLF", 2) }}
          template(v-if="details['ml'] && details['ml'][i] && details['ml'][i][5] != 0 && details['ml'][i][7] != 0 && details['ml'][i][5] != '' && details['ml'][i][7] != ''")
            OddsItem(:odds="details['ml'][i]" idx=5 :typ="oddsType" dataType="2" :mode="'ml'" :count="i" :details="details" homeAway="1")
          template(v-else)
            OddsDisabled
          template(v-if="details['ml'] && details['ml'][i] && details['ml'][i][5] != 0 && details['ml'][i][7] != 0 && details['ml'][i][5] != '' && details['ml'][i][7] != ''")
            OddsItem(:odds="details['ml'][i]" idx=7 :typ="oddsType" dataType="2" :mode="'ml'" :count="i" :details="details" homeAway="2")
          template(v-else)
            OddsDisabled
        .match-odd-area-group
          .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_HDPF", 2) }}
          template(v-if="details['hdp'] && details['hdp'][i] && details['hdp'][i][9] != 0 && details['hdp'][i][10] != 0 && details['hdp'][i][9] != '' && details['hdp'][i][10] != ''")
            OddsItem(:odds="details['hdp'][i]" :idx="details['hdp'][i][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :mode="'hdp'" :count="i" :details="details" homeAway="1")
          template(v-else)
            OddsDisabled
          template(v-if="details['hdp'] && details['hdp'][i] && details['hdp'][i][9] != 0 && details['hdp'][i][10] != 0 && details['hdp'][i][9] != '' && details['hdp'][i][10] != ''")
            OddsItem(:odds="details['hdp'][i]" :idx="details['hdp'][i][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :mode="'hdp'" :count="i" :details="details" homeAway="2")
          template(v-else)
            OddsDisabled
        .match-odd-area-oddtype
          p.mb-0 {{ $t("m.ODD_Over") }}
          p.mb-0 {{ $t("m.ODD_Under") }}
        .match-odd-area-group
          .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_OUF", 2) }}
          template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
            OddsItem(:odds="details['ou'][i]" idx=12 :typ="oddsType" dataType="1" :mode="'ou'" label="over" :count="i" :details="details" homeAway="1")
          template(v-else)
            OddsDisabled
          template(v-if="details['ou'] && details['ou'][i] && details['ou'][i][11] != 0 && details['ou'][i][12] != 0 && details['ou'][i][11] != '' && details['ou'][i][12] != ''")
            OddsItem(:odds="details['ou'][i]" idx=11 :typ="oddsType" dataType="1" :mode="'ou'" label="under" :count="i" :details="details" homeAway="2")
          template(v-else)
            OddsDisabled
        .match-odd-area-oddtype
          p.mb-0 {{ $t("m.ODD_Odd") }}
          p.mb-0 {{ $t("m.ODD_Even") }}
        .match-odd-area-group
          .normal-odd-area-oddtype.text-center.mr-0 {{ $tc("m.BT_OEF", 2) }}
          template(v-if="details['oe'] && details['oe'][i] && details['oe'][i][5] != 0 && details['oe'][i][5] != ''")
            OddsItem(:odds="details['oe'][i]" idx=5 :typ="oddsType" dataType="2")
          template(v-else)
            OddsDisabled
          template(v-if="details['oe'] && details['oe'][i] && details['oe'][i][7] != 0 && details['oe'][i][7] != ''")
            OddsItem(:odds="details['oe'][i]" idx=7 :typ="oddsType" dataType="2")
          template(v-else)
            OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    }
  },
  computed: {
    leagueName() {
      var result = this.details["league"].split(" - ");
      if (result.length >= 2) {
        if (result.length - 2 != 0) {
          if (result.length <= 5) {
            return result[result.length - 2] + " - " + result[result.length - 1];
          }
          if (result.length <= 6) {
            return result[result.length - 3] + " - " + result[result.length - 2] + " - " + result[result.length - 1];
          }
        }
        return result[result.length - 1];
      }
      return this.details["league"];
    }
  }
};
</script>